module.exports = __webpack_public_path__ + "img/spy-guide_in.a7bfa353.png";